if (!customElements.get("add-to-cart")) {
    class AddToCart extends HTMLElement {
        get _variantId() {
            return this.getAttribute("data-variant-id");
        }
        get _quantity() {
            return this.getAttribute("data-quantity") ?? 1;
        }

        constructor() {
            super();
        }
        connectedCallback() {
            this.enableQuickAdd();
        }
        enableQuickAdd() {
            this.addEventListener("click", this.quickAdd.bind(this));
        }
        quickAdd(evt) {
            evt.preventDefault();
            if (this.disabled) {
                return;
            }
            if (this.hasAttribute('disabled')) {
                return;
            }
            this.classList.add("loading");
            this.setAttribute("aria-disabled", true);

            const variantIds = this._variantId.split(",");

            const items = variantIds.map((id) => {
                return {
                    form_type: "product",
                    utf8: "✓",
                    id: parseInt(id, 10),
                    quantity: this._quantity,
                };
            });

            let data_json = {
                items: items,
            };

            const config = {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    'X-Requested-With': 'XMLHttpRequest',
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data_json)
            };

            fetch(`${theme.routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        return;
                    }
                    return this.updateCart(response);
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.classList.remove("loading");
                    this.removeAttribute("aria-disabled");
                });

            return false;
        }
        async updateCart(response) {
            const cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer) {
                const dispatchCustomEvent = function dispatchCustomEvent(eventName) {
                    var data =
                        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    var detail = {
                        detail: data,
                    };
                    var event = new CustomEvent(eventName, data ? detail : null);
                    document.dispatchEvent(event);
                };
                dispatchCustomEvent("cart:item-added", {
                    product: response.hasOwnProperty("items")
                        ? response.items[0]
                        : response,
                });

                cartDrawer.refresh(() => {
                    cartDrawer.open();
                });

            }
        }
        setDisabled(isDisabled, innerText) {
            this.disabled = isDisabled;
            this.disabled ? this.classList.add('disabled') : this.classList.remove('disabled')
            if (innerText) {
                this.firstElementChild.innerText = innerText
            }
        }
    }
    customElements.define("add-to-cart", AddToCart);
}